import axios from 'axios';
import videoItemTemplate from '../../pug/video-list-item.pug';

const init = (instance, $section) => {
    instance.$section = $section;
    instance.apiUrl   = $section.getAttribute('data-next-page');

    if (!instance.apiUrl) {
        return instance;
    }

    let loading    = false;
    let breakpoint = instance.$section.offsetHeight / 2;

    window.addEventListener('scroll', event => {

        let scroll = window.scrollY || window.pageYOffset;

        if (!loading && instance.apiUrl && (scroll > breakpoint)) {

            instance.$section.classList.add('loading');
            loading = true;

            getNewVideos(instance.apiUrl)
                .then(json => {
                    let html = json.data.map(video => {
                        let $wrapper = document.createElement('div')

                        $wrapper.innerHTML = videoItemTemplate({ video });
                        instance.$section.appendChild($wrapper.firstChild);
                    });

                    breakpoint      = instance.$section.offsetHeight / 2;
                    instance.apiUrl = json.pagination.next;
                    instance.$section.classList.remove('loading');
                    loading = false;
                })
        }

    })


};

const getNewVideos = url => axios
    .get(url)
    .then(response => response.data);

export default class VideoList {
    constructor($section) {
        this.$section = null;
        this.apiUrl   = null;

        return $section ? init(this, $section) : {};
    }
}
